import React from 'react';
import { TextField, Card, CardTitle, CardText, CardActions, Button } from 'react-md';
import { Avatar, Chip, SVGIcon } from 'react-md';
import {
  DataTable,
  TableHeader,
  TableCardHeader,
  TableBody,
  TableRow,
  TableColumn,
} from 'react-md';

import AddRunConfigurationDialog from './AddRunConfigurationDialog';
import FlatOrIconButton from './../../../Shared/FlatOrIconButton';
import backend from './../../../App/backend';



class RunConfigurationList extends React.Component {
    constructor(props) {
            super(props);
            this.state = {
              projectId: props.projectId ? props.projectId : props.match.params.projectId,
              runConfigurations: null,
              error1: null,
              isLoaded: false,
              isRunning: false
            };
        }

         componentDidMount() {
                this.fetchRunConfigurations();
              }

      fetchRunConfigurations() {
        fetch(backend.url + '/projects/' + this.state.projectId + '/testPlans')
          .then(res => res.json())
          .then(
            (result) => {
              this.setState({
                isLoaded: true,
                runConfigurations: result.filter(p => !p.deleted)
              });
            },
            (error) => {
              this.setState({
                isLoaded: true,
                error1: error
              });
            }
          )
      }

       addProject1(opts) {
            opts.project = backend.url + '/projects/' + this.state.projectId;
             fetch(backend.url + '/testPlans', {
                  method: 'POST',
                   headers: {
                              'Accept': 'application/json',
                              'Content-Type': 'application/json',
                          },
                  body: JSON.stringify(opts)
                })
                .then(res => res.json())
                .then(
                  (result) => {

                    this.fetchRunConfigurations();
                    this.setState({
                      isLoaded: true,
                      addRowDialogVisible: false,
                      testRun: result
                    });
                  },
                  (error) => {
                    this.setState({
                      isLoaded: true,
                      error1: error
                    });
                  }
                )
            }

       deleteRunConfiguration(id) {
        var opts = {"deleted": "true"};
        fetch(backend.url + '/testPlans/' + id,{
              method: 'PATCH',
               headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                      },
              body: JSON.stringify(opts)
            })
          .then(res => res.json())
          .then(
            (result) => {

              this.setState({
                isLoaded: true
              });
              this.fetchRunConfigurations();

            },
            (error) => {
              this.setState({
                isLoaded: true,
                error1: error
              });
            }
          )
      }

  showAddRowDialog = () => {
//alert("aaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
   this.setState({ addRowDialogVisible: true });

  };

  hideAddRowDialog = () => {
    this.setState({ addRowDialogVisible: false });
  };

  addProject = (projectAttributes1) => {

    var projectAttributes = projectAttributes1[0];

    var project = {
    "name" : projectAttributes['name'],
      "testFramework" : projectAttributes['operatingSystem'],
      "repositoryUrl" : projectAttributes['browser']
      };

    this.addProject1(project);

  };

render() {
var runConfigurations = null;
var error = null;
    if(this.state.isLoaded){
        if(this.state.runConfigurations){
            runConfigurations = this.state.runConfigurations.map((item, i) => (
                               /* <TableRow key={i} >*/
                                <TableRow key={i}>
                                    <TableColumn>{ item.name }</TableColumn>
                                    <TableColumn>{ item.operatingSystem }</TableColumn>
                                    <TableColumn>{ item.browser }</TableColumn>
                                    <TableColumn>
                                        <Button flat primary swapTheming onClick={() => this.deleteRunConfiguration(item.id)}>{'Delete'}</Button>
                                    </TableColumn>
                                  </TableRow>
                              ));
        }



        if(this.state.error1){
            error = this.state.error1.stack;
        }

    }



    return (
 <Card tableCard>
        <TableCardHeader
            title="Run Configurations"
          >
          <FlatOrIconButton onClick={this.showAddRowDialog} iconChildren="add">Add</FlatOrIconButton>
          </TableCardHeader>


<AddRunConfigurationDialog
    visible={this.state.addRowDialogVisible}
    hideAddRowDialog={this.hideAddRowDialog}
    addProject={this.addProject}
/>

<DataTable plain>
    <TableHeader>
      <TableRow>
        <TableColumn>Name</TableColumn>
        <TableColumn>operatingSystem</TableColumn>
        <TableColumn>browser</TableColumn>
        <TableColumn>Action</TableColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
        { runConfigurations }
      { error }
    </TableBody>
  </DataTable>
</Card>
);
}

}

export default RunConfigurationList;



// WEBPACK FOOTER //
// ./src/containers/Project/Detail/RunConfiguration/List.js